import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { WhatsappStatusDto } from './dto/whatsapp-status.dto';
import { StatusSistemaAtendimentoService } from './status-sistema-atendimento.service';

type CorStatus = 'green' | 'orange' | 'red' | 'loading';

@Component({
  selector: 'app-status-sistema-atendimento',
  templateUrl: './status-sistema-atendimento.component.html',
  styleUrls: ['./status-sistema-atendimento.component.scss'],
})
export class StatusSistemaAtendimentoComponent implements OnInit, OnDestroy {
  statusWhatsapp: WhatsappStatusDto | null = null;
  verificando = true;

  private readonly _unsubscribeAll = new Subject<void>();

  constructor(private readonly _statusSistemaAtendimentoService: StatusSistemaAtendimentoService) {}

  ngOnInit(): void {
    this._statusSistemaAtendimentoService.statusWhatsapp$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((status) => {
        this.statusWhatsapp = status;
      });

    this.carregarStatus();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  get corStatus(): CorStatus {
    if (this.verificando) {
      return 'loading';
    }

    if (!this.statusWhatsapp?.ativo) {
      return 'red';
    }

    if (this.statusWhatsapp.saldo > 5) {
      return 'green';
    }

    return 'orange';
  }

  get tooltipStatus(): string {
    switch (this.corStatus) {
      case 'loading':
        return 'Verificando status do BOT WhatsApp...';
      case 'green':
        return `BOT ativo`; // `BOT ativo com saldo de US$ ${this.formatarSaldo(this.statusWhatsapp?.saldo)}`;
      case 'orange':
        return `BOT ativo`; // `BOT ativo com saldo baixo: US$ ${this.formatarSaldo(this.statusWhatsapp?.saldo)}`;
      case 'red':
        return this.statusWhatsapp
          ? 'BOT inativo'
          : 'Erro ao consultar o status do BOT WhatsApp';
      default:
        return '';
    }
  }

  private carregarStatus(): void {
    this.verificando = true;
    this._statusSistemaAtendimentoService.getStatusWhatsapp().subscribe({
      next: () => {
        this.verificando = false;
      },
      error: () => {
        this.verificando = false;
      },
    });
  }

  private formatarSaldo(saldo?: number): string {
    if (saldo == null) {
      return '—';
    }

    return saldo.toFixed(2);
  }
}
